// Experimental SOSSA variants, based on SpikeSorterDraft sections 4.3.1–4.3.2.
export const isSossaDataset = (dataset) => (
  [dataset?.algorithmName, dataset?.name, dataset?.metadata?.algorithmName,
    dataset?.metadata?.algorithm_name, dataset?.metadata?.algorithm]
    .some((name) => String(name || '').trim().toLowerCase() === 'sossa')
);

export const sossaNumber = (value) => (
  typeof value === 'number' && Number.isFinite(value) ? value : null
);

export const sossaConfidence = (best, second) => {
  if (sossaNumber(best) === null || sossaNumber(second) === null || best <= 0 || second < 0 || second > best) return null;
  return (best - second) / best;
};

export const hasSossaFields = (cluster) => (
  ['best_match', 'second_match', 'num_fs_spikes'].some((key) => cluster?.[key] !== undefined)
);

export const sossaCoverage = (cluster) => {
  const total = sossaNumber(cluster.num_fs_spikes);
  const count = cluster.spikeTimes?.length || 0;
  return total > 0 && count <= total ? count / total : null;
};

// Centered boxcar; even windows have one more bin on the right. Outside bins are zero.
export const movingAverage = (values, window) => {
  const width = Math.max(1, Math.min(1001, Math.trunc(Number(window)) || 1));
  const before = Math.floor((width - 1) / 2);
  const sums = [0];
  values.forEach((value) => sums.push(sums[sums.length - 1] + value));
  return values.map((_, index) => (
    (sums[Math.min(values.length, index + width - before)] - sums[Math.max(0, index - before)]) / width
  ));
};

export const sossaProfiles = (clusters, binWidth = 1) => {
  if (!(binWidth > 0) || !Number.isFinite(binWidth)) return [];
  // Require uploaded primary-channel scalar amplitudes; waveform previews may be sampled.
  return clusters.map((cluster) => {
    const values = (cluster.spikeAmplitudes || []).filter((value) => sossaNumber(value) !== null);
    const counts = new Map();
    values.forEach((value) => {
      const bin = Math.floor(value / binWidth);
      counts.set(bin, (counts.get(bin) || 0) + 1);
    });
    return { cluster, counts, count: values.length,
      complete: values.length > 0 && values.length === cluster.spikeTimes?.length };
  });
};

export const profileSeries = (profile, binWidth, window) => {
  const bins = [...profile.counts.keys()];
  if (!bins.length) return { x: [], y: [], tooWide: false };
  const low = bins.reduce((a, b) => Math.min(a, b));
  const high = bins.reduce((a, b) => Math.max(a, b));
  if (!Number.isSafeInteger(low) || !Number.isSafeInteger(high) || high - low > 20000) return { x: [], y: [], tooWide: true };
  const x = Array.from({ length: high - low + 1 }, (_, index) => (low + index) * binWidth);
  const counts = x.map((_, index) => profile.counts.get(low + index) || 0);
  return { x, y: movingAverage(counts, window), tooWide: false };
};

